import { Inject, Injectable } from '@angular/core';
import { I18nPluralPipe, NgLocalization } from '@angular/common';
import { DEFAULT_NAMING_KEY, ModelNameLower, ModelNameTitle } from '@shared/naming/naming.module';
import { NamingConfig } from '@shared/naming/naming-config';

type PluralMap = { [count: string]: string };
type Pluralizer = {
  readonly singular: string;
  readonly plural: string;
  pluralize: (value: number | null | undefined) => string;
};

@Injectable()
export class ModelNameService {
  readonly lower!: Pluralizer;
  readonly title!: Pluralizer;
  readonly plural!: string;
  readonly singular!: string;
  pluralize!: Pluralizer['pluralize'];
  private pipe: I18nPluralPipe;

  constructor(
    localization: NgLocalization,
    @Inject(DEFAULT_NAMING_KEY) public readonly defaultKey: string,
    @Inject(ModelNameTitle) public readonly titleMaps: Record<string, PluralMap>,
    @Inject(ModelNameLower) public readonly lowerMaps: Record<string, PluralMap>
  ) {
    this.pipe = new I18nPluralPipe(localization);
    Object.assign(this, this.for(defaultKey));
  }

  for(model: string | NamingConfig) {
    const key = typeof model === 'string' ? model : model.key;
    const title = this.from(this.titleMaps[key]);
    return {
      title,
      lower: this.from(this.lowerMaps[key]),
      singular: title.singular,
      plural: title.plural,
      pluralize: title.pluralize,
    };
  }

  from(map: PluralMap): Pluralizer {
    return {
      get singular() {
        return this.pluralize(1);
      },
      get plural() {
        return this.pluralize(5);
      },
      pluralize: (value: number | null | undefined) => {
        return this.pipe.transform(value, map);
      },
    };
  }
}
